import * as React from 'react';

function HintIconComponent(props: any) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1C4.6 1 1 4.6 1 9C1 13.4 4.6 17 9 17C13.4 17 17 13.4 17 9C17 4.6 13.4 1 9 1ZM9 15.5C5.4 15.5 2.5 12.6 2.5 9C2.5 5.4 5.4 2.5 9 2.5C12.6 2.5 15.5 5.4 15.5 9C15.5 12.6 12.6 15.5 9 15.5ZM9 6.5C9.55228 6.5 10 6.05228 10 5.5C10 4.94772 9.55228 4.5 9 4.5C8.44772 4.5 8 4.94772 8 5.5C8 6.05228 8.44772 6.5 9 6.5ZM9.69995 12.2H9.99995C10.4 12.2 10.8 12.5 10.8 13C10.8 13.5 10.4 13.8 9.99995 13.8H7.99995C7.49995 13.8 7.19995 13.5 7.19995 13C7.19995 12.5 7.59995 12.2 7.99995 12.2H8.19995V8.70001H7.99995C7.59995 8.70001 7.19995 8.40001 7.19995 8.00001C7.19995 7.60001 7.59995 7.20001 7.99995 7.20001H8.89995C9.39995 7.20001 9.69995 7.60001 9.69995 8.00001V12.2Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default HintIconComponent;
